import { rem } from 'polished'
import styled from 'styled-components'

import { TextFieldStyled } from '../../../elements/TextField/styles/TextFieldStyled'

export const FormStyled = styled.form``

FormStyled.displayName = 'FormStyled'
